import { SortOrder } from '@retro-ui/api-contract';

import { SortingElement } from '../components/filtering/components/SortingCard';

const isSortOrder = (value: string): value is SortOrder => ['asc', 'desc'].includes(value);

export function parseSorting(sortingStr: string | null) {
  if (sortingStr == null) {
    return undefined;
  }

  const sorting = sortingStr.split(';').flatMap<SortingElement>(elementStr => {
    const [attribute, direction] = elementStr.split(',');

    if (attribute && isSortOrder(direction)) {
      return [[attribute, direction]];
    }

    return [];
  });

  return sorting;
}
